import { type IPromoBank } from '../../../types/promos';

export function getBankLogoUrl(bank: IPromoBank): string | null {
  return bank.secondSquareImageUrl || bank.logoUrl || null;
}
